import * as React from "react";
import glamorous from "glamorous";
import {
	Header as HeaderText,
	Container,
	Menu,
	Button,
	Segment
} from "semantic-ui-react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { withAuth, AuthProps } from "../../helpers/WithLoggedIn";
import DownloadContainer from "../../pages/BusinessPlanPage/components/DownloadContainer";

export interface HeaderProps extends RouteComponentProps<{}>, AuthProps {}

const Header: React.SFC<HeaderProps> = props => (
	<Menu
		// fixed={fixed ? 'top' : null}
		// inverted={!fixed}
		// pointing={!fixed}
		// secondary={!fixed}
		size="small"
		as='header'
	>
		<Container>
			<Menu.Item as={Link} to="/" active={props.location.pathname == "/"}>
				Home
			</Menu.Item>
			<Menu.Item
				as={Link}
				to="/owners"
				active={!!props.location.pathname.match("/owners")}
			>
				Owners Profile
			</Menu.Item>
			<Menu.Item
				as={Link}
				to="/strategy"
				active={!!props.location.pathname.match("/strategy")}
			>
				Business Strategy
			</Menu.Item>
			<Menu.Item
				as={Link}
				to="/marketing"
				active={!!props.location.pathname.match("/marketing")}
			>
				Marketing
			</Menu.Item>
			<Menu.Item
				as={Link}
				to="/operations"
				active={!!props.location.pathname.match("/operations")}
			>
				Operations & Admin
			</Menu.Item>
			<Menu.Item
				as={Link}
				to="/businessplan"
				active={!!props.location.pathname.match("/businessplan")}
			>
				Business Plan
			</Menu.Item>
			<Menu.Item position="right">
				{props.authDetails.isLoggedIn && <DownloadContainer/>}
				{!props.authDetails.isLoggedIn && (
					<>
						<Button as={Link} to="/login">
							Log in
						</Button>
						<Button
							as={Link}
							style={{ marginLeft: "0.5em" }}
							to="/register"
						>
							Sign Up
						</Button>
					</>
				)}
			</Menu.Item>
		</Container>
	</Menu>
);

export default withRouter(withAuth(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.tsx